export default "__VITE_ASSET__CwOqcdl1__"